const tableDataGenerator = (columns, len) => {
	let out = []
	for (let i = 1; i <= len; i += 1) {
		const num = i.toString().padStart(3, '0'),
			name = `Test_${num}`
		let dataObj = {}
		columns.forEach(({ accessor }) => {
			if(accessor === 'name') {
				dataObj[accessor] = name
			} else if (accessor === 'number') {
				dataObj[accessor] = num
			} else {
				dataObj[accessor] = Math.floor(Math.random() * 100) + (+Math.random().toFixed(2))
			}
		})
		out.push(dataObj)
	}
	return out
}

export default tableDataGenerator
